$(function () {
  function extractDomain(host) {
    let parts = host.split(".");
    parts.shift();
    return parts.join(".");
  }
});

$(function () {
  const refKeys = ['top', 'top_slide', 'main', 'menu', 'footer', 'footer_magazine', 'sp', 'section_footer'];

  function sanitizeRefParams(searchParams) {
    let modified = false;
    if (refKeys.includes(searchParams.get('ref'))) {
      searchParams.delete('ref');
      modified = true;
    }
    refKeys.forEach(key => {
      if (searchParams.has(key)) {
        searchParams.delete(key);
        modified = true;
      }
    });
    return modified;
  }

  function getBaseDomain(hostname) {
    const parts = hostname.split('.');
    return parts.length >= 2 ? parts.slice(-2).join('.') : hostname;
  }

  function isSameSite(url) {
    try {
      return getBaseDomain(url.hostname) === getBaseDomain(location.hostname);
    } catch (e) {
      return false;
    }
  }

  function updateLinks(containerId, refValue) {
    const $container = $('#' + containerId);
    if ($container.length === 0) return;

    $container.find('a[href], button[onclick]')
      .not('.top__search a, .top__search button, .top__search * a, .top__search * button, #header-identity a, .footer a')
      .each(function () {
        const $el = $(this);

        // === aタグ処理 ===
        if (this.tagName.toLowerCase() === 'a') {
          let href = $el.attr('href');
          if (!href || href.startsWith('javascript:') || href.startsWith('#')) return;

          let url;
          try {
            const isAbsoluteUrl = /^https?:\/\//i.test(href);
            url = isAbsoluteUrl ? new URL(href) : new URL(href, location.origin);
          } catch (e) {
            return;
          }

          if (!isSameSite(url)) return;

          let searchParams = url.searchParams;
          sanitizeRefParams(searchParams);
          searchParams.set('ref', refValue);

          let newHref = url.origin + url.pathname + '?' + searchParams.toString() + url.hash;
          $el.attr('href', newHref);
        }

        // === buttonタグ処理 ===
        if (this.tagName.toLowerCase() === 'button') {
          let onclick = $el.attr('onclick');
          if (!onclick) return;

          let updatedOnclick = onclick.replace(/(https?:\/\/[^\s'"]+)/g, function (match) {
            let url;
            try {
              const isAbsoluteUrl = /^https?:\/\//i.test(match);
              url = isAbsoluteUrl ? new URL(match) : new URL(match, location.origin);
            } catch (e) {
              return match;
            }

            if (!isSameSite(url)) return match;

            let searchParams = url.searchParams;
            sanitizeRefParams(searchParams);
            searchParams.set('ref', refValue);

            return url.origin + url.pathname + '?' + searchParams.toString() + url.hash;
          });

          $el.attr('onclick', updatedOnclick);
        }
      });
  }

  // 各コンテナに対して実行
  updateLinks('home', 'top');
  updateLinks('sidebar', 'menu');
  updateLinks('common-banner-placeholder', 'footer');
  updateLinks('smartphone', 'sp');
  updateLinks('footer', 'section_footer');

  // .splide_home a に ?ref=top_slide を追加（サブドメインを許容）
  $('.splide_home a[href]').each(function () {
    const $el = $(this);
    let href = $el.attr('href');
    if (!href || href.startsWith('javascript:') || href.startsWith('#')) return;

    let url;
    try {
      url = new URL(href);
    } catch (e) {
      return;
    }

    if (!isSameSite(url)) return;

    let searchParams = url.searchParams;
    sanitizeRefParams(searchParams);
    searchParams.set('ref', 'top_slide');

    let newHref = url.origin + url.pathname + '?' + searchParams.toString() + url.hash;
    $el.attr('href', newHref);
  });

  // アドレスバーのパラメータを削除
  const cleanUrl = new URL(window.location.href);
  const params = cleanUrl.searchParams;
  const changed = sanitizeRefParams(params);

  if (changed) {
    const newUrl = cleanUrl.pathname + (params.toString() ? '?' + params.toString() : '') + cleanUrl.hash;
    history.replaceState(null, '', newUrl);
  }
});

$(function(){
  // 外部リンクへtarget/rel付与
  $("a[href]").each(function(){
    var h=$(this).attr("href");
    if(!/^https?:\/\//.test(h))return;
    try{
      var l=new URL(h).host,c=location.host;
      if(l!==c)$(this).attr({target:"_blank",rel:"nofollow noopener noreferrer"})
    }catch(e){}
  });
});

